var render = function render(){var _vm=this,_c=_vm._self._c;return (+_vm.computedPrepay === 1)?_c('div',{staticClass:"notif-box mrg-t-10 shadow-card"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_c('b',[_vm._v("Внимание! Перед посещением вас могут попросить внести предоплату")])])
}]

export { render, staticRenderFns }